import * as storage from '../../utils/storage';
import { ApolloError, useMutation } from '@apollo/client';
import { SILENT_LOGIN } from '../../state/mutations/User';
import { decodeToken } from '../../utils/jwt/jwt-helper';
import { useEffect, useState } from 'react';
import { useInitAnalytics } from '../useInitAnalytics';
import { useInterval } from '../useInterval';
import { useManageToken } from './useManageToken';
import { useStores } from '../useStores';


type useLoginProps ={
    logout: () => void;
    setInitLogin: (value: boolean) => void;
    setModalVisible?: (value: boolean) => void;
    ignoreIfNoToken?: boolean;

}


export const useSilentLogin = ({logout, setInitLogin, setModalVisible = () => {}, ignoreIfNoToken = false} : useLoginProps) => {
  const rootStore = useStores();
  const { initAnalyticsWithToken } = useInitAnalytics();
  const token = rootStore?.user?.user?.tokenExpires;
  const [tokenExpired, setTokenExpired] = useState(!!token && (Date.now() - token > 0));

  const loginCb = () => {
    setInitLogin(true);
    setModalVisible(false);

  };

  useInterval(() => {
    setTokenExpired(!!token && (Date.now() - token > 0));
  }, 10000);

  const manageToken = useManageToken(loginCb);

  const [silentLoginMutation] = useMutation(
    SILENT_LOGIN,
    {
      fetchPolicy: 'no-cache',
      onCompleted: async data => {
        if (data && 'silentLogin' in data) {
          const decodedData = decodeToken(data.silentLogin);
          if (!decodedData || decodedData.forceLogout) {
            await logout();
          } else {
            manageToken(data.silentLogin);
          }
          // I go out if token does not seem valid anymore, if no attempt of getting push token has been ever done or if preferrred language is not set
        } else {
          await logout();
        }
      },
      onError: (err: ApolloError) => {
        if ((err as any)?.graphQLErrors[0]?.translationKey === 'ERROR.AUTH_ERROR.NOT_ACTIVE') {
          setModalVisible(true);
          setInitLogin(true);
        } else {
          logout();
        }
      }
    });

  const manageLogin = async (): Promise<void> => {
    const user = rootStore?.user?.user;

    if(!user || !user?.tokenExpires) {
      logout();
      return;
    }
    if ((Date.now() - user!.tokenExpires > 0)) {
      const tok = await storage.loadString('token');
      if (tok) {
        silentLoginMutation();
      } else {
        await logout();
      }
    } else {
      setInitLogin(true);
      rootStore?.afterLoad();
      const tok = await storage.loadString('token');
      if(tok) {
        initAnalyticsWithToken(tok);
      }
    }

  };

  useEffect(() => {
    if(!ignoreIfNoToken || !!token)  manageLogin();
  }, [ignoreIfNoToken, tokenExpired, token]);

  return {manageLogin};

};
